export default class GetAllConvocatorias {
  #repository
  constructor(repository) {
    this.#repository = repository
  }
  async execute() {
    try {
      const result = await this.#repository.getAllConvocatorias()
      return result
    } catch (error) {
      console.error('Error al obtener las convocatorias:', error)
      throw error
    }
  }
}
